var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { createElement, useCallback, useState } from 'react';
import { Collapse } from 'react-collapse';
import styled from 'styled-components';
import { IconButton, TextButton } from '@creditornot/cb-button';
import { colors, cssVarsThemed, typographyCss } from '@creditornot/cb-ingredients';
import { createCssVarDefinitions, createCssVars, pxToRem } from '@creditornot/cb-utils';
import AlertCircleFillIcon from './icons/AlertCircleFill';
import CheckIcon from './icons/Check';
import CrossIcon from './icons/Cross';
import InfoCircleFillIcon from './icons/InfoCircleFill';
var sizeConfigs = {
    small: {
        iconSize: 12,
        padding: 8,
        typography: typographyCss.Small,
        lineHeight: 16,
    },
    medium: {
        iconSize: 16,
        padding: 16,
        typography: typographyCss.Body3,
        lineHeight: 20,
    },
};
var cssVars = createCssVars(['iconSize', 'padding', 'lineHeight']);
var ErrorIcon = styled(AlertCircleFillIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  width: ", ";\n  fill: ", ";\n"], ["\n  display: block;\n  width: ", ";\n  fill: ", ";\n"])), cssVars.iconSize, colors.strawberry100);
var InfoIcon = styled(InfoCircleFillIcon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n\n  display: block;\n  width: ", ";\n  fill: var(--iconFill);\n"], ["\n  ", "\n\n  display: block;\n  width: ", ";\n  fill: var(--iconFill);\n"])), cssVarsThemed({
    iconFill: {
        light: colors.pepper100,
        dark: colors.salt100,
    },
}), cssVars.iconSize);
var SuccessIconBG = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n\n  width: ", ";\n  height: ", ";\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: ", ";\n\n  svg {\n    width: 55%;\n    fill: var(--iconFill);\n  }\n"], ["\n  ", "\n\n  width: ", ";\n  height: ", ";\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: ", ";\n\n  svg {\n    width: 55%;\n    fill: var(--iconFill);\n  }\n"])), cssVarsThemed({
    iconFill: {
        light: colors.salt100,
        dark: colors.pepper100,
    },
}), cssVars.iconSize, cssVars.iconSize, colors.lime100);
var SuccessIcon = function () { return (React.createElement(SuccessIconBG, null,
    React.createElement(CheckIcon, null))); };
var WarningIcon = styled(AlertCircleFillIcon)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: block;\n  width: ", ";\n  fill: ", ";\n"], ["\n  display: block;\n  width: ", ";\n  fill: ", ";\n"])), cssVars.iconSize, colors.banana100);
var variantConfigs = {
    error: {
        backgroundColor: {
            light: colors.strawberry8,
            dark: colors.strawberry16,
        },
        icon: ErrorIcon,
    },
    info: {
        backgroundColor: {
            light: colors.pepper8,
            dark: colors.salt12,
        },
        icon: InfoIcon,
    },
    success: {
        backgroundColor: {
            light: colors.lime8,
            dark: colors.lime16,
        },
        icon: SuccessIcon,
    },
    warning: {
        backgroundColor: {
            light: colors.banana8,
            dark: colors.banana16,
        },
        icon: WarningIcon,
    },
};
var variantCssVars = createCssVars(['backgroundColor', 'color']);
var Root = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n\n  ", "\n\n  box-sizing: border-box;\n  min-width: 100px;\n  max-width: 100%;\n  display: flex;\n  align-items: stretch;\n  justify-content: stretch;\n  border-radius: 8px;\n  flex-shrink: 0;\n  color: ", ";\n  background-color: ", ";\n  padding: ", ";\n  ", "\n  line-height: ", ";\n\n  .ReactCollapse--collapse {\n    transition: height 400ms cubic-bezier(0.19, 1, 0.22, 1); /* easeOutExpo */\n  }\n"], ["\n  ", "\n\n  ", "\n\n  box-sizing: border-box;\n  min-width: 100px;\n  max-width: 100%;\n  display: flex;\n  align-items: stretch;\n  justify-content: stretch;\n  border-radius: 8px;\n  flex-shrink: 0;\n  color: ", ";\n  background-color: ", ";\n  padding: ", ";\n  ", "\n  line-height: ", ";\n\n  .ReactCollapse--collapse {\n    transition: height 400ms cubic-bezier(0.19, 1, 0.22, 1); /* easeOutExpo */\n  }\n"])), function (_a) {
    var $size = _a.$size;
    return createCssVarDefinitions({
        iconSize: "".concat(sizeConfigs[$size].iconSize, "px"),
        padding: "".concat(sizeConfigs[$size].padding, "px"),
        lineHeight: pxToRem(sizeConfigs[$size].lineHeight),
    });
}, function (_a) {
    var $variant = _a.$variant;
    return cssVarsThemed({
        backgroundColor: variantConfigs[$variant].backgroundColor,
        color: {
            light: colors.pepper100,
            dark: colors.salt100,
        },
    });
}, variantCssVars.color, variantCssVars.backgroundColor, cssVars.padding, function (_a) {
    var $size = _a.$size;
    return sizeConfigs[$size].typography;
}, cssVars.lineHeight);
var Col = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n"], ["\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n"])));
var LeftCol = styled(Col)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  flex-shrink: 0;\n  padding-inline-end: 8px;\n"], ["\n  flex-shrink: 0;\n  padding-inline-end: 8px;\n"])));
var RightCol = styled(Col)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  flex: 1;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n"], ["\n  flex: 1;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n"])));
var IconContainer = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  height: ", ";\n  padding-inline-start: 4px;\n"], ["\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  height: ", ";\n  padding-inline-start: 4px;\n"])), cssVars.lineHeight);
var TitleRow = styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  display: flex;\n  box-sizing: border-box;\n  max-width: 100%;\n"], ["\n  display: flex;\n  box-sizing: border-box;\n  max-width: 100%;\n"])));
var TitleContainer = styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  min-width: 0;\n  flex: 1;\n  display: flex;\n"], ["\n  min-width: 0;\n  flex: 1;\n  display: flex;\n"])));
var Title = styled.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-weight: 700;\n  white-space: nowrap;\n"], ["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-weight: 700;\n  white-space: nowrap;\n"])));
// when children is rendered in the title
var TitleContent = styled.div(templateObject_13 || (templateObject_13 = __makeTemplateObject([""], [""])));
var TitleColumn = styled.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  flex-shrink: 0;\n  padding-inline-start: ", ";\n"], ["\n  flex-shrink: 0;\n  padding-inline-start: ", ";\n"])), cssVars.padding);
var CloseButtonContainer = styled.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  height: ", ";\n"], ["\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  height: ", ";\n"])), cssVars.lineHeight);
var Content = styled.div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n  margin-top: 4px;\n"], ["\n  margin-top: 4px;\n"])));
var ShowMoreContent = styled.div(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n  padding-top: 4px;\n  min-height: 0;\n  min-width: 0;\n"], ["\n  padding-top: 4px;\n  min-height: 0;\n  min-width: 0;\n"])));
var ShowMoreButton = styled(TextButton).attrs({ size: 'inherit' })(templateObject_18 || (templateObject_18 = __makeTemplateObject([""], [""])));
var Alert = function (_a) {
    var children = _a.children, closeButtonProps = _a.closeButtonProps, onCloseButtonClick = _a.onCloseButtonClick, showMoreContent = _a.showMoreContent, _b = _a.size, size = _b === void 0 ? 'medium' : _b, title = _a.title, titleRightContent = _a.titleRightContent, _c = _a.variant, variant = _c === void 0 ? 'info' : _c, rest = __rest(_a, ["children", "closeButtonProps", "onCloseButtonClick", "showMoreContent", "size", "title", "titleRightContent", "variant"]);
    var _d = __read(useState(false), 2), open = _d[0], setOpen = _d[1];
    var handleShowMoreButtonClick = useCallback(function () { return setOpen(function (value) { return !value; }); }, []);
    return (React.createElement(Root, __assign({ "$size": size, "$variant": variant, role: "alert" }, rest),
        React.createElement(LeftCol, null,
            React.createElement(IconContainer, null, createElement(variantConfigs[variant].icon))),
        React.createElement(RightCol, null,
            React.createElement(TitleRow, null,
                React.createElement(TitleContainer, null, title ? React.createElement(Title, { title: title }, title) : React.createElement(TitleContent, null, children)),
                !!titleRightContent && React.createElement(TitleColumn, null, titleRightContent),
                !!showMoreContent && (React.createElement(TitleColumn, null,
                    React.createElement(ShowMoreButton, { onClick: handleShowMoreButtonClick, variant: "grey" }, open ? 'Less' : 'More'))),
                !!onCloseButtonClick && (React.createElement(TitleColumn, null,
                    React.createElement(CloseButtonContainer, null,
                        React.createElement(IconButton, __assign({}, closeButtonProps, { alignment: "iconEdges", "aria-label": "Close alert", background: "animated", onClick: onCloseButtonClick, size: "tiny", variant: "grey" }),
                            React.createElement(CrossIcon, null)))))),
            !!children && !!title && React.createElement(Content, null, children),
            !!showMoreContent && (React.createElement(Collapse, { isOpened: open },
                React.createElement(ShowMoreContent, null, showMoreContent))))));
};
export default Alert;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18;
//# sourceMappingURL=Alert.js.map